import { useDictionaryService, useDictionaryValue } from '../../dictionary/reactBindings/hooks';
import type { UseAnyDictionaryService, UseAnyDictionaryValue } from '../../dictionary/reactBindings/types';
import { UITranslations } from '../UITranslations';

export const useUITranslationService: UseAnyDictionaryService = (...args) => {
  return useDictionaryService(UITranslations, ...args);
};

export const useUITranslation: UseAnyDictionaryValue = (...args) => {
  return useDictionaryValue(UITranslations, ...args);
};
